// extracted by css-extract-rspack-plugin
export default {"tools-Layout":"tools-Layout-fIyE2D","toolsLayout":"tools-Layout-fIyE2D"};